import { render, staticRenderFns } from "./SupplierRiskTabIndirect.vue?vue&type=template&id=129500da&"
import script from "./SupplierRiskTabIndirect.vue?vue&type=script&lang=js&"
export * from "./SupplierRiskTabIndirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports